const { get } = require("jquery");

jQuery(document).ready(function ($) {
  var ajaxUrl =
    document
      .querySelector('meta[name="glidertech-ajax-url"]')
      ?.getAttribute("content") || "/wp-admin/admin-ajax.php";

  // on page load, if GET param exists, set select value to GET param
  var url = new URL(window.location.href);
  var type = url.searchParams.get("type");

  $(".knowledge-hub--filters select").each(function () {
    var select = $(this);
    var grid = $(this).closest(".knowledge-hub").find(".kh-card--grid");
    var blockAjax = false; // Flag to block AJAX call

    // Initialize select2 on your select element
    select.select2({
      placeholder: "Filter",
      minimumResultsForSearch: Infinity,
      allowClear: false,
    });
    // If type is set in URL, set it as the value, else set to default
    if (type) {
      select.val(type).trigger("change");
    } else {
      select.val("").trigger("change"); // Set the select to default value on load
    }

    // Listen for when an option is selected
    select.one("select2:select", function (e) {
      blockAjax = true; // Set flag to true to block AJAX
      // Add the 'All' option just once and at the top
      var newOption = new Option("All", "all", false, false);
      newOption.setAttribute("id", "allOption");
      // Prepend the 'All' option
      $(this).prepend(newOption);
      $(this).val(e.params.data.id).trigger("change"); // Set value back to selected value
      blockAjax = false; // Set flag back to false after manual change
    });

    // AJAX call on change event of the select
    select.on("change", function () {
      // If the blockAjax flag is true, return early
      if (blockAjax) return;

      // Define the value
      var value = $(this).val();

      // Make AJAX call
      $.ajax({
        url: ajaxUrl,
        type: "GET",
        data: {
          action: "filter_knowledge",
          filter: value,
        },
        dataType: "json",
        success: function (result) {
          if (value !== "all") {
            // Using URL API, set query string of type=value
            var url = new URL(window.location.href);
            url.searchParams.set("type", value);
            // Replace current URL in browser with new URL
            history.replaceState(null, null, url.toString());
          } else {
            // Using URL API, remove query string of type
            var url = new URL(window.location.href);
            url.searchParams.delete("type");
            // Replace current URL in browser with new URL
            history.replaceState(null, null, url.toString());
          }

          if (result.more_posts) {
            $(".kh-loading").show();
          } else {
            $(".kh-loading").hide();
          }

          grid.html(result.content);

          if ($(".kh-card--grid .kh-card--item").length < 7) {
            $(".kh-loading").hide();
          }
        },
        error: function () {
          grid.html("Failed to fetch data.");
        },
      });
    });
  });

  $(".kh-loading .load-more").on("click", function (e) {
    e.preventDefault();

    $.ajax({
      type: "GET",
      url: ajaxUrl,
      data: {
        action: "knowledge",
        offset: $(".kh-card--grid .kh-card--item").length + 1,
        type: new URL(window.location.href).searchParams.get("type") || "all",
      },
      dataType: "json",
      beforeSend: function () {
        $(".kh-loading .load-more").text("Loading...");
      },
      success: function (result) {
        $(".kh-loading .load-more").text("Load more");
        if (result.more_posts == false) {
          $(".kh-loading").hide();
        } else {
          $(".kh-loading").show();
        }

        $(".kh-card--grid").append(result.content);
      },
    });
  });
});
